/* tms-compte.js — le compte dans la boutique (lot 18) : « Sign in » ou l'icône de compte et son menu dans
   l'en-tête, « My galleries » au catalogue, et la garde automatique de la famille de la page (lot 15 comptes :
   plus aucun encart « Keep my family »). Contrat : docs/identite-contrat.md §4, §6, §8.

   🔴 UNE SEULE SONDE PAR PAGE. `GET <galerie>/moi/galeries` avec le cookie ; sur un 401, UN SEUL
   `POST <api>/v1/auth/refresh` puis UN SEUL nouvel essai (porté de tms-gallery.js, `avecSession`) ; le tout
   borné à 4 s. 200 ⇒ connecté (et la liste vient avec) ; tout le reste (401, panne, CORS, délai) ⇒
   « Sign in », sans erreur écrite. Aucun autre appel de session n'existe tant que le visiteur n'a pas fait
   un geste (ouvrir une galerie, se déconnecter) — sauf la garde automatique, UNE fois par jeton et par onglet.
   🔴 AUCUN JETON DANS UNE ADRESSE. Le jeton d'une galerie vit dans l'onglet (`tms_jeton`, posé par le bloc
   tms-gallery) ; la clé de création à côté (`tms_cle_creation`, `{jeton, cle}`), jamais envoyée ailleurs
   qu'à `POST /famille/<jeton>/garder`. `retour` est la page courante sans paramètre de jeton.
   ⚠️ Aucun texte n'est écrit ici : tout vient des `data-t-*` de la racine `[data-tms-compte]` de l'en-tête. */
(function () {
  "use strict";

  var CLE_GALERIE = "tms_jeton";
  var CLE_CREATION = "tms_cle_creation";
  var DELAI_MS = 4000;
  var PARAMS_SECRETS = ["tms", "token", "jeton", "tms_jeton", "access_token", "id_token", "code"];

  /* ── « My family » dans l'en-tête (lot 22) ────────────────────────────────────────────────────────
     🔴 LE LIEN BASCULE SUR UNE FAMILLE EN COURS OU PRÊTE (lot 28 comptes ; lot 03 boutique-un-ecran, décision 5 d'Alex
     du 25/10) — il ne basculait qu'à « prête » (lot 22) : personne ne redemande de créer la famille qu'on dessine, et
     My family sait l'attendre. Le VERDICT vient de la galerie (la mémoire de l'appareil n'est qu'un jeton) ou d'une
     galerie prête du compte connecté. 🔴 UN JETON MORT
     (404, famille échouée) QUITTE LA MÉMOIRE : laissé là, il ferait relire une famille perdue à chaque page. Une
     panne passagère (`indisponible`, réseau) ne décide rien. Le jeton part dans le CHEMIN d'un `GET` à la galerie,
     jamais dans une adresse de page. Cette partie vit hors de `[data-tms-compte]` : sans page de connexion, la mémoire
     suffit.
     🔴 LE SIGNAL « DÉJÀ FAIT » (lot 03) : chaque verdict est rangé (`tms_famille_etat`) et posé sur
     `html[data-tms-famille]`, que le script de tête (snippets/tms-deja-fait.liquid) relit au chargement suivant AVANT
     le premier rendu ; un jeton mort retire les deux. Une famille créée sur la page (annoncée `tms:famille` par le
     bloc) est jugée sur l'annonce, sans recharger. */
  var CLE_MEMOIRE = "tms_ma_famille";
  var CLE_ETAT = "tms_famille_etat";
  var lienFamille = document.querySelector("[data-tms-ma-famille]");
  var familleDe = { appareil: false, compte: false };
  /* L'appel servi, lu sur la balise : le texte peut déjà dire « My family » si le signal l'a peint ci-dessous. */
  var lienCreer = lienFamille && { texte: lienFamille.dataset.tCreer || lienFamille.textContent,
    href: lienFamille.dataset.creer || lienFamille.getAttribute("href") };

  function memoire() {
    try {
      return window.localStorage.getItem(CLE_MEMOIRE);
    } catch (e) {
      return null;
    }
  }

  function poserSignal(etat) {
    try {
      if (etat) window.localStorage.setItem(CLE_ETAT, etat);
      else window.localStorage.removeItem(CLE_ETAT);
    } catch (e) {
      /* stockage refusé : le signal vaut pour cette page */
    }
    if (etat) document.documentElement.setAttribute("data-tms-famille", etat);
    else document.documentElement.removeAttribute("data-tms-famille");
  }

  function oublierMemoire(jeton) {
    try {
      if (window.localStorage.getItem(CLE_MEMOIRE) === jeton) {
        window.localStorage.removeItem(CLE_MEMOIRE);
        poserSignal(null);
      }
      if ((window.localStorage.getItem("tms_galerie_courante") || "").indexOf(JSON.stringify(jeton)) !== -1)
        window.localStorage.removeItem("tms_galerie_courante");
    } catch (e) {
      /* stockage refusé : rien n'était gardé */
    }
  }

  function peindreLienFamille() {
    if (!lienFamille) return;
    var oui = familleDe.appareil || familleDe.compte;
    lienFamille.textContent = oui ? lienFamille.dataset.tMaFamille : lienCreer.texte;
    lienFamille.setAttribute("href", oui ? lienFamille.dataset.maFamille : lienCreer.href);
  }

  /* Le verdict de la galerie sur la famille de l'appareil (`jeton`). */
  function juger(jeton, f) {
    if (!f || !jeton) return;
    var m = memoire();
    /* 🔴 (revue) « échouée » vaut aussi quand la galerie a DÉJÀ effacé la mémoire (`oublierFamille`, sans annonce) :
       sans cela, le signal restait posé sur une famille que plus rien ne retient. */
    if (f.etat === "échouée" && (!m || m === jeton)) {
      if (m) oublierMemoire(jeton);
      else poserSignal(null);
      familleDe.appareil = false;
    } else if (jeton !== m) {
      return;
    } else if (f.etat === "prête" || f.etat === "en_cours") {
      poserSignal(f.etat === "prête" ? "prete" : "en-cours");
      familleDe.appareil = true;
    } else {
      return;
    }
    peindreLienFamille();
  }

  /* Un état sans mémoire (effacée ailleurs) ne pose rien (script de tête) : on le range, il ne doit pas survivre
     jusqu'à la prochaine famille retenue avant son verdict. */
  if (!memoire()) poserSignal(null);
  /* Le signal de tête est déjà posé : le menu le suit tout de suite (le verdict confirmera ou défera). */
  if (document.documentElement.hasAttribute("data-tms-famille") && memoire()) {
    familleDe.appareil = true;
    peindreLienFamille();
  }

  /* (lot 07 comptes) Chaque lecture annoncée (`tms:famille` : le bandeau, un 404 y devient « échouée » ; le bloc de la
     galerie, y compris une famille CRÉÉE sur la page) est jugée pour la famille de l'appareil. */
  document.addEventListener("tms:famille", function (ev) {
    var d = ev.detail || {};
    juger(d.jeton, d.famille);
  });

  (function verifierMemoire() {
    var jeton = memoire();
    var service = lienFamille ? (lienFamille.dataset.service || "").replace(/\/$/, "") : "";
    if (!jeton || !service) return;
    /* LE BANDEAU LIT DÉJÀ CETTE FAMILLE : on l'écoute (ci-dessus) au lieu de relire — une seule lecture par page.
       ⚠️ Seulement s'il lit LA MÊME famille (il suit l'onglet d'abord) et qu'il a une adresse de galerie (revue). */
    var bandeau = document.querySelector("[data-tms-bandeau]");
    var onglet = lireOnglet(CLE_GALERIE);
    if (bandeau && (bandeau.dataset.service || "").trim() && (!onglet || onglet === jeton)) return;
    fetch(service + "/famille/" + encodeURIComponent(jeton), { credentials: "omit" })
      .then(function (r) {
        if (r.status === 404) return { etat: "échouée" };
        return r.ok ? r.json() : null;
      })
      .then(function (f) {
        juger(jeton, f);
      })
      .catch(function () {
        /* injoignable : rien n'est décidé */
      });
  })();

  var racine = document.querySelector("[data-tms-compte]");
  if (!racine) return;
  var cfg = {
    service: (racine.dataset.service || "").replace(/\/$/, ""),
    api: (racine.dataset.api || "").replace(/\/$/, ""),
    connexion: racine.dataset.connexion || "",
    fiche: racine.dataset.fiche || "",
  };
  var t = racine.dataset;
  var etat = { connu: false, connecte: false, galeries: [], famille: null };

  /* 🔴 (lot 10, R3) LA GALERIE DE LA FAMILLE DE L'APPAREIL. `/moi/galeries` ne rend aucun jeton (identifiant opaque) :
     le lien entre la famille que l'appareil suit (`tms_ma_famille`, annoncée par `tms:famille`) et SA ligne vient de
     qui les connaît tous deux — le rangement à l'envoi (tms-gallery.js, `POST /famille/<jeton>/ranger` rend l'id) ou
     l'adoption d'une famille en cours (`adopterEnCours`). Cette ligne-là montre l'exemple atténué, « Being drawn » et
     les minutes ; à « prête », sans recharger, l'aperçu de SA famille et « Open ». Les autres lignes ne changent pas. */
  var CLE_COURANTE = "tms_galerie_courante";
  var annonces = {};

  /* (revue) la ligne suivie n'a de sens que pour la famille que l'appareil retient : sinon elle est oubliée (un jeton
     ne reste jamais en mémoire sans raison). */
  function galerieCourante() {
    try {
      var c = JSON.parse(window.localStorage.getItem(CLE_COURANTE) || "null");
      if (c && typeof c.jeton === "string" && typeof c.id === "string" && c.jeton === memoire()) return c;
      if (c) oublierGalerieCourante();
    } catch (e) {
      /* stockage refusé ou illisible : aucune ligne suivie */
    }
    return null;
  }

  function oublierGalerieCourante() {
    try {
      window.localStorage.removeItem(CLE_COURANTE);
    } catch (e) {
      /* rien n'était gardé */
    }
  }

  function retenirGalerieCourante(jeton, id) {
    try {
      window.localStorage.setItem(CLE_COURANTE, JSON.stringify({ jeton: jeton, id: id }));
    } catch (e) {
      /* stockage refusé : la ligne reste « Being drawn » jusqu'au rechargement */
    }
  }

  function lireOnglet(cle) {
    try {
      return window.sessionStorage.getItem(cle);
    } catch (e) {
      return null;
    }
  }

  function jetonCourant() {
    return lireOnglet(CLE_GALERIE);
  }

  /* La clé de création de la galerie COURANTE seulement : une clé rangée pour une autre galerie ne part pas. */
  function cleCourante() {
    var j = jetonCourant();
    try {
      var c = JSON.parse(lireOnglet(CLE_CREATION) || "null");
      return c && c.jeton === j && typeof c.cle === "string" ? c.cle : null;
    } catch (e) {
      return null;
    }
  }

  function remplacer(modele, valeurs) {
    return String(modele || "").replace(/%(\w+)%/g, function (m, k) {
      return k in valeurs ? valeurs[k] : m;
    });
  }

  /* L'adresse de la page commune, avec le retour vers CETTE page (même étape : le fragment suit),
     sans aucun paramètre qui porterait un secret (contrat §10). */
  function adresseConnexion() {
    var retour = window.location.href;
    try {
      var u = new URL(retour);
      PARAMS_SECRETS.forEach(function (p) {
        u.searchParams.delete(p);
      });
      if (/(^|[#&])(tms|jeton|token)=/.test(u.hash)) u.hash = "";
      retour = u.toString();
    } catch (e) {
      retour = window.location.origin + window.location.pathname;
    }
    return cfg.connexion + (cfg.connexion.indexOf("?") === -1 ? "?" : "&") + "retour=" + encodeURIComponent(retour);
  }

  function delai(promesse) {
    return Promise.race([
      promesse,
      new Promise(function (_, rejeter) {
        window.setTimeout(function () {
          rejeter(new Error("délai"));
        }, DELAI_MS);
      }),
    ]);
  }

  /* Un accès expiré n'est pas une déconnexion : un seul refresh, un seul nouvel essai (contrat §8). */
  function avecSession(appel) {
    return appel().then(function (r) {
      if (r.status !== 401 || !cfg.api) return r;
      return delai(fetch(cfg.api + "/v1/auth/refresh", { method: "POST", credentials: "include" })).then(
        function (rf) {
          return rf.ok ? appel() : r;
        },
        function () {
          return appel();
        }
      );
    });
  }

  function lire(r) {
    return r
      .json()
      .catch(function () {
        return {};
      })
      .then(function (c) {
        return { statut: r.status, corps: c || {} };
      });
  }

  /* La sonde de l'en-tête (`?sonde=1`, lot 18) : sans accès, la galerie répond `200 {connecte: false}` — aucun 401
     dans la console d'un visiteur — et `renouveler` quand une session longue existe : alors UN refresh, UN nouvel
     essai. Un accès présenté mais refusé reste un 401, renouvelé de même (`avecSession`). */
  function lireGaleries() {
    return fetch(cfg.service + "/moi/galeries?sonde=1", { credentials: "include" });
  }

  function corps(r) {
    return r.ok ? r.json() : null;
  }

  function sonder() {
    return delai(
      avecSession(lireGaleries)
        .then(corps)
        .then(function (c) {
          if (!c || c.connecte !== false || !c.renouveler || !cfg.api) return c;
          return fetch(cfg.api + "/v1/auth/refresh", { method: "POST", credentials: "include" }).then(function (rf) {
            return rf.ok ? lireGaleries().then(corps) : null;
          });
        })
    )
      .then(
        function (c) {
          etat.connecte = !!c && c.connecte !== false;
          etat.galeries = (etat.connecte && c.galeries) || [];
          etat.famille = (etat.connecte && c.famille_compte) || null;
          familleDe.compte = etat.galeries.some(function (g) {
            return g.etat === "prête";
          });
          peindreLienFamille();
          adopterEnCours();
        },
        function () {
          etat.connecte = false;
        }
      )
      .then(function () {
        etat.connu = true;
        peindre();
        garderAuto();
        annoncerSession();
      });
  }

  /* (lot 09 comptes) Le verdict de la sonde, pour le bandeau « histoire » (tms-histoire.js) : un événement, et un attribut
     sur <html> pour un script qui arrive après. Aucune seconde sonde : c'est la seule. */
  function annoncerSession() {
    document.documentElement.setAttribute("data-tms-session", etat.connecte ? "connecte" : "anonyme");
    try {
      document.dispatchEvent(new CustomEvent("tms:session", { detail: { connecte: etat.connecte } }));
    } catch (e) {
      /* un écouteur cassé n'arrête pas l'en-tête */
    }
  }

  /* 🔴 LA FAMILLE EN COURS SUIT LE COMPTE (lot 07 comptes, D6). Sur un appareil qui ne retient AUCUNE famille, la
     famille du compte connecté encore EN COURS (une création envoyée connecté, la dernière de la liste) est ouverte
     (`POST /moi/galeries/<id>/ouvrir`) et retenue : ouverte depuis le compte, sa provenance est sûre. Le bandeau
     (tms-bandeau.js) l'apprend par `tms:memoire` et suit son attente. Une famille déjà retenue n'est jamais remplacée. */
  function adopterEnCours() {
    /* La page « My family » résout ELLE-MÊME la famille du compte (la prête la plus récente) : deux résolveurs
       feraient une course sur la même mémoire. */
    if (!etat.connecte || memoire() || document.querySelector('[data-tms-mode="ma-famille"]')) return;
    var enCours = etat.galeries.filter(function (g) {
      return g.etat === "en_cours" && g.id;
    });
    var g = enCours[enCours.length - 1];
    if (!g) return;
    fetch(cfg.service + "/moi/galeries/" + encodeURIComponent(g.id) + "/ouvrir", { method: "POST", credentials: "include" })
      .then(corps)
      .then(function (c) {
        if (!c || typeof c.jeton !== "string" || memoire()) return;
        try {
          window.localStorage.setItem(CLE_MEMOIRE, c.jeton);
          window.sessionStorage.setItem("tms_jeton_sur", c.jeton);
          retenirGalerieCourante(c.jeton, g.id);
        } catch (e) {
          return; /* stockage refusé : rien n'est retenu, rien n'est annoncé */
        }
        document.dispatchEvent(new CustomEvent("tms:memoire", { detail: { jeton: c.jeton } }));
      })
      .catch(function () {
        /* injoignable : l'appareil reste sans famille, rien n'est décidé */
      });
  }

  /* ── L'en-tête : « Sign in », ou l'icône et son menu ─────────────────────────────────────────────── */
  var lienConnexion = racine.querySelector("[data-tms-compte-connexion]");
  var boutonMenu = racine.querySelector("[data-tms-compte-bouton]");
  var menu = racine.querySelector("[data-tms-compte-menu]");
  var sortie = racine.querySelector("[data-tms-compte-sortie]");

  function items() {
    /* (lot 17) une entrée cachée (« Add WhatsApp » d'un compte qui a déjà son numéro) n'est pas atteignable au clavier */
    return menu ? Array.prototype.slice.call(menu.querySelectorAll('[role="menuitem"]')).filter(function (n) {
      return !n.closest("[hidden]");
    }) : [];
  }

  function ouvrirMenu() {
    if (!menu || !boutonMenu) return;
    menu.hidden = false;
    boutonMenu.setAttribute("aria-expanded", "true");
    var premier = items()[0];
    if (premier) premier.focus();
  }

  function fermerMenu(rendreFocus) {
    if (!menu || !boutonMenu || menu.hidden) return;
    menu.hidden = true;
    boutonMenu.setAttribute("aria-expanded", "false");
    if (rendreFocus) boutonMenu.focus();
  }

  if (boutonMenu && menu) {
    boutonMenu.addEventListener("click", function () {
      if (menu.hidden) ouvrirMenu();
      else fermerMenu(false);
    });
    boutonMenu.addEventListener("keydown", function (ev) {
      if (ev.key === "ArrowDown" && menu.hidden) {
        ev.preventDefault();
        ouvrirMenu();
      }
    });
    menu.addEventListener("keydown", function (ev) {
      var liste = items();
      var i = liste.indexOf(document.activeElement);
      if (ev.key === "Escape") {
        ev.preventDefault();
        fermerMenu(true);
      } else if (ev.key === "ArrowDown" || ev.key === "ArrowUp") {
        ev.preventDefault();
        var n = liste.length;
        liste[(i + (ev.key === "ArrowDown" ? 1 : n - 1)) % n].focus();
      } else if (ev.key === "Home" || ev.key === "End") {
        ev.preventDefault();
        liste[ev.key === "Home" ? 0 : liste.length - 1].focus();
      } else if (ev.key === "Tab") {
        fermerMenu(false);
      }
    });
    document.addEventListener("click", function (ev) {
      if (!racine.contains(ev.target)) fermerMenu(false);
    });
  }

  function seDeconnecter(rendreFocus) {
    return fetch(cfg.api + "/v1/auth/logout", { method: "POST", credentials: "include" })
      .catch(function () {
        return null;
      })
      .then(function () {
        etat.connecte = false;
        etat.galeries = [];
        etat.famille = null;
        familleDe.compte = false;
        oublierGalerieCourante();
        peindreLienFamille();
        peindre();
        /* (revue) le bandeau « histoire » l'apprend aussi : plus de choix de famille, le bouton passe par la connexion */
        annoncerSession();
        if (rendreFocus && lienConnexion) lienConnexion.focus();
      });
  }

  if (sortie) {
    sortie.addEventListener("click", function () {
      fermerMenu(false);
      seDeconnecter(true);
    });
  }

  /* ── « Delete my family » / « Delete my account » (lot 25 comptes, R4, D4-D7) ───────────────────────────────────
     🔴 UNE FENÊTRE AVANT TOUT EFFACEMENT : elle dit ce qui part et ce qui reste (fichiers print des commandes payées,
     13 mois), puis « Delete » ou « Cancel » ; le focus va d'abord sur « Cancel ». `DELETE <galerie>/moi/familles` ou
     `/moi/compte` (session, Origin). Réussi : les mémoires de l'appareil oublient toute famille (sinon le bandeau et
     « My family » relisent une famille effacée), la liste est RELUE (sonde), et pour le compte la déconnexion suit.
     Un échec ne dit jamais « fait » : le serveur n'a rien effacé (503 si le support n'a pas pu être prévenu). */
  var fenetre = racine.querySelector("[data-tms-compte-effacer-fenetre]");
  var effacement = { mode: "", fini: false };

  function dansFenetre(sel) {
    return fenetre.querySelector(sel);
  }

  function oublierFamilles() {
    [CLE_MEMOIRE, CLE_COURANTE].forEach(function (cle) {
      try {
        window.localStorage.removeItem(cle);
      } catch (e) {
        /* stockage fermé : rien à oublier */
      }
    });
    [CLE_GALERIE, CLE_CREATION, "tms_jeton_sur", "tms_jeton_parcours"].forEach(function (cle) {
      try {
        window.sessionStorage.removeItem(cle);
      } catch (e) {
        /* idem */
      }
    });
    familleDe.appareil = false;
    familleDe.compte = false;
    poserSignal(null);
    peindreLienFamille();
    document.dispatchEvent(new CustomEvent("tms:familles-effacees"));
  }

  function ouvrirEffacement(mode) {
    effacement.mode = mode;
    effacement.fini = false;
    var pre = "effacer-" + mode;
    dansFenetre("[data-tms-effacer-titre]").textContent = racine.getAttribute("data-t-" + pre + "-titre") || "";
    dansFenetre("[data-tms-effacer-part]").textContent = racine.getAttribute("data-t-" + pre + "-part") || "";
    dansFenetre("[data-tms-effacer-reste]").textContent = racine.getAttribute("data-t-" + pre + "-reste") || "";
    dansFenetre("[data-tms-effacer-message]").textContent = "";
    var oui = dansFenetre("[data-tms-effacer-oui]");
    var non = dansFenetre("[data-tms-effacer-annuler]");
    oui.hidden = false;
    oui.disabled = false;
    non.disabled = false;
    if (non.tmsTexte == null) non.tmsTexte = non.textContent;
    non.textContent = non.tmsTexte;
    fermerMenu(false);
    fenetre.showModal();
    non.focus();
  }

  function confirmerEffacement() {
    var oui = dansFenetre("[data-tms-effacer-oui]");
    var non = dansFenetre("[data-tms-effacer-annuler]");
    var message = dansFenetre("[data-tms-effacer-message]");
    var mode = effacement.mode;
    oui.disabled = true;
    non.disabled = true;
    effacement.enVol = true;
    message.textContent = t.tEffacerEnCours || "";
    avecSession(function () {
      return fetch(cfg.service + (mode === "compte" ? "/moi/compte" : "/moi/familles"), {
        method: "DELETE",
        credentials: "include",
      });
    })
      .then(function (r) {
        effacement.enVol = false;
        if (!r.ok) throw r.status;
        effacement.fini = true;
        oublierFamilles();
        message.textContent = racine.getAttribute("data-t-effacer-" + mode + "-fait") || "";
        oui.hidden = true;
        non.disabled = false;
        non.textContent = t.tFermer || non.tmsTexte;
        non.focus();
        return mode === "compte" ? seDeconnecter(false) : sonder();
      })
      .catch(function (statut) {
        effacement.enVol = false;
        if (effacement.fini) return;
        /* 500 : une partie est déjà partie (revue du lot 25) ; tout autre refus : rien n'a été effacé. */
        message.textContent = (statut === 500 ? t.tEffacerIncomplet : t.tEffacerPanne) || "";
        oui.disabled = false;
        non.disabled = false;
      });
  }

  if (fenetre && typeof fenetre.showModal === "function") {
    racine.querySelectorAll("[data-tms-compte-effacer]").forEach(function (b) {
      b.addEventListener("click", function () {
        ouvrirEffacement(b.getAttribute("data-tms-compte-effacer") === "compte" ? "compte" : "familles");
      });
    });
    dansFenetre("[data-tms-effacer-oui]").addEventListener("click", confirmerEffacement);
    dansFenetre("[data-tms-effacer-annuler]").addEventListener("click", function () {
      fenetre.close();
    });
    /* revue du lot 25 : Échap pendant l'effacement fermerait la fenêtre, qui se lirait « annulé » alors que la demande
       est partie ; on attend sa réponse. */
    fenetre.addEventListener("cancel", function (e) {
      if (effacement.enVol) e.preventDefault();
    });
    fenetre.addEventListener("close", function () {
      /* le focus revient au geste : l'icône du compte, ou « Sign in » si le compte vient d'être effacé */
      var cible = etat.connecte ? boutonMenu : lienConnexion;
      if (cible && !cible.hidden) cible.focus();
    });
  } else {
    /* sans <dialog> (navigateur très ancien) : pas de bouton qui ne mènerait nulle part */
    racine.querySelectorAll("[data-tms-compte-effacer]").forEach(function (b) {
      b.closest("li").hidden = true;
    });
  }

  /* ── « Add WhatsApp » (lot 17 comptes, D6) ───────────────────────────────────────────────────────────────
     🔴 OFFERT SEULEMENT À UN COMPTE SANS NUMÉRO : les moyens viennent de `GET <api>/v1/me`, lu à l'OUVERTURE du menu (un
     geste : la sonde de la page reste la seule sans geste), une fois par page. Numéro, puis code à 6 chiffres reçu sur
     WhatsApp : `POST /v1/auth/whatsapp/verifier` avec la session courante RÉUNIT le compte au compte WhatsApp (lot 02,
     le compte WhatsApp survit, les cookies sont reposés), puis « My galleries » est relue : la famille du bot y paraît.
     Un refus `409 deja_rattache` (compte abonné, déjà réuni, numéro à plusieurs fiches) est dit, jamais forcé. */
  var waItem = racine.querySelector("[data-tms-compte-wa]");
  var waPanneau = racine.querySelector("[data-tms-compte-wa-panneau]");
  var moyens = null;
  var RE_TEL = /^\+[1-9]\d{7,14}$/;

  function lireMoyens() {
    if (moyens || !cfg.api || !waItem) return;
    moyens = "en-cours";
    /* (revue du lot 17) le même « un refresh, un seul nouvel essai » que la sonde : l'accès vit 15 min, le menu peut
       s'ouvrir bien après. */
    delai(avecSession(function () {
      return fetch(cfg.api + "/v1/me", { credentials: "include" });
    }).then(corps))
      .then(
        function (c) {
          moyens = c && Array.isArray(c.moyens) ? c.moyens : null;
        },
        function () {
          moyens = null;
        }
      )
      .then(function () {
        waItem.hidden = !(etat.connecte && moyens && moyens.indexOf("whatsapp") === -1);
      });
  }

  function telephone(valeur) {
    var v = String(valeur || "").replace(/[\s().\-]/g, "");
    if (v.indexOf("00") === 0) v = "+" + v.slice(2);
    return RE_TEL.test(v) ? v : "";
  }

  /* Le statut d'une réponse de l'API d'identité ; une panne rend 0. ⚠️ Chaque `fetch` écrit sa route EN CLAIR : le filet
     §11 lit le texte des appels pour vérifier qu'aucun ne sort des routes de session. */
  function statutDe(promesse) {
    return promesse.then(
      function (r) {
        return r.status;
      },
      function () {
        return 0;
      }
    );
  }

  var JSON_IDENTITE = { "Content-Type": "application/json" };

  if (waItem && waPanneau) {
    var waTel = waPanneau.querySelector("[data-tms-compte-wa-tel]");
    var waCode = waPanneau.querySelector("[data-tms-compte-wa-code]");
    var waZoneCode = waPanneau.querySelector("[data-tms-compte-wa-zone-code]");
    var waEnvoyer = waPanneau.querySelector("[data-tms-compte-wa-envoyer]");
    var waVerifier = waPanneau.querySelector("[data-tms-compte-wa-verifier]");
    var waMessage = waPanneau.querySelector("[data-tms-compte-wa-message]");
    var waNumero = "";
    var dire = function (phrase) {
      if (waMessage) waMessage.textContent = phrase || "";
    };
    var fermerWa = function () {
      waPanneau.hidden = true;
      if (boutonMenu) boutonMenu.focus();
    };
    if (boutonMenu) boutonMenu.addEventListener("click", lireMoyens);
    waItem.querySelector("[data-tms-compte-wa-ouvrir]").addEventListener("click", function () {
      fermerMenu(false);
      dire("");
      waPanneau.hidden = false;
      if (waTel) waTel.focus();
    });
    waPanneau.querySelector("[data-tms-compte-wa-fermer]").addEventListener("click", fermerWa);
    waPanneau.addEventListener("keydown", function (ev) {
      if (ev.key === "Escape") {
        ev.preventDefault();
        fermerWa();
      } else if (ev.key === "Enter" && (ev.target === waTel || ev.target === waCode)) {
        ev.preventDefault();
        (ev.target === waTel ? waEnvoyer : waVerifier).click();
      }
    });
    waEnvoyer.addEventListener("click", function () {
      var tel = telephone(waTel.value);
      if (!tel) {
        dire(t.tWaNumero);
        waTel.focus();
        return;
      }
      waEnvoyer.disabled = true;
      statutDe(fetch(cfg.api + "/v1/auth/whatsapp", {
        method: "POST", credentials: "include", headers: JSON_IDENTITE, body: JSON.stringify({ telephone: tel }),
      })).then(function (statut) {
        waEnvoyer.disabled = false;
        if (statut !== 202 && statut !== 200) {
          dire(statut === 400 ? t.tWaNumero : t.tWaPanne);
          waTel.focus();
          return;
        }
        waNumero = tel;
        if (waZoneCode) waZoneCode.hidden = false;
        dire((t.tWaEnvoye || "").replace("%TEL%", tel));
        waCode.value = "";
        waCode.focus();
      });
    });
    waVerifier.addEventListener("click", function () {
      var c = String(waCode.value || "").replace(/\s/g, "");
      if (!/^\d{6}$/.test(c) || !waNumero) {
        dire(t.tWaCodeRequis);
        waCode.focus();
        return;
      }
      waVerifier.disabled = true;
      statutDe(fetch(cfg.api + "/v1/auth/whatsapp/verifier", {
        method: "POST", credentials: "include", headers: JSON_IDENTITE, body: JSON.stringify({ telephone: waNumero, code: c }),
      })).then(function (statut) {
        waVerifier.disabled = false;
        if (statut === 200) {
          moyens = null;
          waItem.hidden = true;
          if (waZoneCode) waZoneCode.hidden = true;
          dire(t.tWaFait);
          /* « Confirm » désactivé pendant l'appel a perdu le focus : il revient dans le panneau (Échap le ferme). */
          waPanneau.querySelector("[data-tms-compte-wa-fermer]").focus();
          /* La réunion a changé le compte (le numéro survit) : « My galleries » est relue, la famille du bot y paraît. */
          sonder();
          return;
        }
        dire(statut === 429 ? t.tWaTrop : statut === 409 ? t.tWaRefus
          : statut === 400 ? t.tWaCodeFaux : t.tWaPanne);
        waCode.focus();
      });
    });
    document.addEventListener("click", function (ev) {
      if (!waPanneau.hidden && !racine.contains(ev.target)) waPanneau.hidden = true;
    });
  }

  /* (lot 17) Une connexion faite dans le formulaire de la boutique (Google, WhatsApp) : l'en-tête relit la session. */
  document.addEventListener("tms:connecte", function () {
    moyens = null;
    sonder();
  });

  /* ── « My galleries » ────────────────────────────────────────────────────────────────────────────── */
  function dateLisible(iso) {
    if (!iso) return "";
    var d = new Date(iso + "T12:00:00Z");
    if (isNaN(d.getTime())) return "";
    try {
      return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
    } catch (e) {
      return iso;
    }
  }

  function personnes(n) {
    return remplacer(n === 1 ? t.tPersonne : t.tPersonnes, { n: n });
  }

  function badge(pret, echouee) {
    var s = document.createElement("span");
    s.className = "badge " + (pret ? "badge--ok" : echouee ? "badge--bientot" : "badge--info");
    s.textContent = pret ? t.tPrete : echouee ? t.tEchouee : t.tEnCours;
    return s;
  }

  /* Ouvre une famille et mène à la fiche du mug, #order-preview, le jeton rangé dans l'onglet (jamais dans
     l'adresse) — le même chemin que le chat Nino (lot 17). */
  function mener(jeton) {
    var range = true;
    try {
      window.sessionStorage.setItem(CLE_GALERIE, jeton);
      /* ouverte depuis le compte : provenance sûre (lot 22), l'appareil pourra la retenir */
      window.sessionStorage.setItem("tms_jeton_sur", jeton);
    } catch (e) {
      range = false;
    }
    var cible = cfg.fiche + (range ? "#order-preview" : "#tms=" + encodeURIComponent(jeton));
    var memePage = window.location.pathname.replace(/\/$/, "") === cfg.fiche.replace(/\/$/, "");
    window.location.assign(cible);
    if (memePage) window.location.reload();
  }

  function ouvrir(bouton, requete, message) {
    bouton.disabled = true;
    message.textContent = "";
    avecSession(requete)
      .then(lire)
      .then(function (rep) {
        if (rep.statut === 200 && rep.corps.jeton) return mener(rep.corps.jeton);
        throw new Error("HTTP " + rep.statut);
      })
      .catch(function () {
        bouton.disabled = false;
        message.textContent = t.tOuvertureEchec || "";
      });
  }

  function ligne(liste, message, pret, meta, note, requete, id, image, echouee) {
    var li = document.createElement("li");
    li.className = "galerie";
    if (id) li.setAttribute("data-id", id);
    if (image) {
      var img = document.createElement("img");
      img.className = "galerie__img" + (image.attente ? " galerie__img--attente" : "");
      img.alt = "";
      img.width = 56;
      img.height = 56;
      li.className += " galerie--image";
      li.appendChild(img);
      /* (lot 22 comptes) SA famille composée par le navigateur quand le service sert sa pose. */
      montrerFamille(img, cfg.service, image.src, image.pose, { maquette: true });
    }
    li.appendChild(badge(pret, echouee));
    var m = document.createElement("span");
    m.className = "galerie__meta";
    m.textContent = meta[0];
    if (meta[1]) {
      var sous = document.createElement("span");
      sous.textContent = meta[1];
      m.appendChild(sous);
    }
    li.appendChild(m);
    if (pret && requete) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "galerie__act";
      b.textContent = t.tOuvrir;
      b.setAttribute("aria-label", remplacer(t.tOuvrirLabel, { quoi: meta.filter(Boolean).join(", ") }));
      b.addEventListener("click", function () {
        ouvrir(b, requete, message);
      });
      li.appendChild(b);
    } else if (note) {
      var n = document.createElement("span");
      n.className = "galerie__note";
      n.textContent = note;
      li.appendChild(n);
    }
    liste.appendChild(li);
  }

  function minutesRestantes(fam) {
    if (!fam || fam.etat !== "en_cours" || typeof fam.restant_estime_s !== "number") return "";
    var n = Math.max(1, Math.ceil(fam.restant_estime_s / 60));
    return n === 1 ? t.tMinute || "" : remplacer(t.tMinutes, { n: n });
  }

  function varianteApercu(fam) {
    return ((fam && fam.variantes) || []).filter(function (x) {
      return x && x.apercu;
    })[0] || null;
  }

  /* 🔴 LOT 22 comptes : LE COMPOSITEUR DU SERVICE (`pose.js`), chargé une fois par page — la balise est partagée avec les
     autres scripts du thème ; le bloc en charge peut-être une autre, `pose.js` ne s'installe qu'une fois. Il ne vient
     pas (réseau, service ancien, 8 s) : `null`, et l'image du serveur s'affiche. */
  function avecPose(base) {
    if (window.TmsPose) return Promise.resolve(window.TmsPose);
    return new Promise(function (ok) {
      var fini = false;
      function fin() { if (!fini) { fini = true; ok(window.TmsPose || null); } }
      function finie() { s.setAttribute("data-tms-pose-fini", ""); }
      var s = document.querySelector("script[data-tms-pose-js]");
      /* (revue du lot 22) une balise déjà FINIE (chargée ou tombée) ne rappellera plus personne : sans `TmsPose`,
         l'image du serveur tout de suite, pas après 8 s. Les trois chargeurs (bloc, compte, histoire) la partagent. */
      if (s && s.hasAttribute("data-tms-pose-fini")) return fin();
      if (!s) {
        s = document.createElement("script");
        s.src = base + "/pose.js";
        s.async = true;
        s.setAttribute("data-tms-pose-js", "");
        s.addEventListener("load", finie);
        s.addEventListener("error", finie);
        (document.head || document.documentElement).appendChild(s);
      }
      s.addEventListener("load", fin);
      s.addEventListener("error", fin);
      window.setTimeout(fin, 8000);
    });
  }

  /* L'image de SA famille : composée par le navigateur quand le service sert sa pose (`TmsPose.montrer` émet `load`
     quand elle est à l'écran), sinon l'image du serveur — avec les mêmes `onload` / `onerror`. */
  function montrerFamille(img, base, src, pose, o) {
    if (!pose) {
      if (window.TmsPose) window.TmsPose.retirer(img);  /* la composition d'avant ne reste pas par-dessus */
      img.src = src;
      return;
    }
    avecPose(base).then(function (tp) {
      if (!tp || !tp.montrer) img.src = src;
      else tp.montrer(img, Object.assign({ service: base, jpeg: src, pose: pose }, o || {}));
    });
  }


  function suivreAnnonce(d) {
    var courante = galerieCourante();
    if (!d || !d.famille || !courante || d.jeton !== courante.jeton) return;
    var avant = annonces[d.jeton];
    annonces[d.jeton] = d.famille;
    if (avant && avant.etat === d.famille.etat && minutesRestantes(avant) === minutesRestantes(d.famille)) return;
    if (!etat.connecte) return;
    if (avant && avant.etat === d.famille.etat) {
      /* (revue) seules les minutes changent : la note, à sa place, sans reconstruire la liste (le focus reste) */
      document.querySelectorAll('[data-tms-galeries-liste] li[data-id="' + courante.id + '"] .galerie__note')
        .forEach(function (n) {
          n.textContent = minutesRestantes(d.famille) || t.tLienCourriel;
        });
      return;
    }
    document.querySelectorAll("[data-tms-galeries]").forEach(peindreGaleries);
  }

  document.addEventListener("tms:famille", function (ev) {
    suivreAnnonce(ev.detail);
  });
  (function () {
    var b = document.querySelector("[data-tms-bandeau]");
    if (b && b.tmsDerniere) suivreAnnonce(b.tmsDerniere);
  })();

  function peindreGaleries(zone) {
    var liste = zone.querySelector("[data-tms-galeries-liste]");
    var vide = zone.querySelector("[data-tms-galeries-vide]");
    var message = zone.querySelector("[data-tms-galeries-message]");
    if (!liste) return;
    liste.textContent = "";
    if (etat.famille) {
      var f = etat.famille;
      var origine = f.origine === "whatsapp" ? t.tDeWhatsapp : f.origine === "chat" ? t.tDuChat : "";
      ligne(liste, message, true, [personnes(f.membres), origine], "", function () {
        return fetch(cfg.service + "/famille/import", {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: "{}",
        });
      });
    }
    var courante = galerieCourante();
    var exemple = zone.getAttribute("data-exemple") || "";
    etat.galeries.forEach(function (g) {
      var suivie = courante && courante.id === g.id ? annonces[courante.jeton] : null;
      var pret = g.etat === "prête" || (!!suivie && suivie.etat === "prête");
      /* (revue) une famille ÉCHOUÉE n'est pas « Being drawn » : ni attente, ni image, ni lien promis */
      var echouee = !pret && (g.etat === "échouée" || (!!suivie && suivie.etat === "échouée"));
      var origine = g.origine === "whatsapp" ? t.tDeWhatsapp : g.origine === "chat" ? t.tDuChat : "";
      var sous = [dateLisible(g.date), origine].filter(Boolean).join(" · ");
      var note = pret || echouee ? "" : minutesRestantes(suivie) || t.tLienCourriel;
      var va = pret && suivie ? varianteApercu(suivie) : null;
      var image = va ? { src: cfg.service + va.apercu, pose: va.pose }
        : !pret && !echouee && exemple ? { src: exemple, attente: true } : null;
      ligne(liste, message, pret, [personnes(g.membres || 0), sous], note, function () {
        return fetch(cfg.service + "/moi/galeries/" + encodeURIComponent(g.id) + "/ouvrir", {
          method: "POST",
          credentials: "include",
        });
      }, g.id, image, echouee);
    });
    if (vide) vide.hidden = liste.children.length > 0;
  }

  /* ── La garde automatique (lot 15 comptes, D2 d'Alex) ────────────────────────────────────────────── */
  /* 🔴 PLUS D'ENCART : la famille que la page connaît se lie seule au compte dès que la sonde dit « connecté » —
     l'onglet (`tms_jeton`, posé par le bloc), un `#tms=` dans l'adresse (le lien du courriel « ready » ouvert sur un
     autre appareil, avant que le bloc ne le range), sinon la mémoire de l'appareil. 🔴 C'EST LE SERVEUR QUI JUGE LA
     PREUVE : la clé de création de CETTE galerie, ou l'adresse prouvée par la session égale à celle de la galerie ;
     sinon `409 code_requis`, et ici le SILENCE (D3 : le code reste côté serveur, sans écran qui l'appelle).
     UNE fois par jeton et par onglet (`tms_garde_auto`), jamais de boucle. Seule `famille_pas_prete` rend une chance :
     UN nouvel essai quand le bandeau annonce CETTE famille prête. Gardée ⇒ « My galleries » relue (la sonde). */
  var CLE_GARDE_AUTO = "tms_garde_auto";
  var attendPrete = "";

  function jetonDeLaPage() {
    var j = jetonCourant();
    if (j) return j;
    var m = /(?:^|[#&])tms=([^&]+)/.exec(window.location.hash);
    if (m) {
      try {
        return decodeURIComponent(m[1]);
      } catch (e) {
        return null;
      }
    }
    return memoire();
  }

  function garderAuto() {
    var j = etat.connecte && jetonDeLaPage();
    if (!j || lireOnglet(CLE_GARDE_AUTO) === j) return;
    try {
      window.sessionStorage.setItem(CLE_GARDE_AUTO, j);
    } catch (e) {
      return; /* sans stockage d'onglet, aucune garde : rien ne la bornerait à une seule */
    }
    var cle = cleCourante();
    avecSession(function () {
      return fetch(cfg.service + "/famille/" + encodeURIComponent(j) + "/garder", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cle ? { cle: cle } : {}),
      });
    })
      .then(lire)
      .then(function (rep) {
        if (rep.statut === 200 && rep.corps.statut === "rattache") return sonder();
        if (rep.statut === 409 && rep.corps.erreur === "famille_pas_prete") attendPrete = j;
        return null;
      })
      .catch(function () {
        /* injoignable : rien n'est dit, la famille garde son lien */
      });
  }

  /* `famille_pas_prete` : la garde est rendue possible, une fois, quand CETTE famille devient prête. */
  function rendreUneChance(d) {
    if (!attendPrete || !d || d.jeton !== attendPrete || !d.famille || d.famille.etat !== "prête") return;
    attendPrete = "";
    try {
      window.sessionStorage.removeItem(CLE_GARDE_AUTO);
    } catch (e) {
      return;
    }
    garderAuto();
  }

  /* ── Peindre tout ce qui dépend de la session ────────────────────────────────────────────────────── */
  /* Un élément conditionnel est visible selon la sonde : connecté (`data-tms-si-connecte`) ou non
     (`data-tms-si-anonyme`). */
  function visible(n) {
    if (n.hasAttribute("data-tms-si-anonyme") && etat.connecte) return false;
    if (n.hasAttribute("data-tms-si-connecte") && !etat.connecte) return false;
    return true;
  }

  /* `sansListe` (revue du lot 10) : une annonce de famille repeint les zones, jamais la liste « My galleries »,
     que `suivreAnnonce` tient à jour en place (la reconstruire toutes les 5 s faisait perdre le focus). */
  function peindre(sansListe) {
    racine.setAttribute("data-etat", etat.connecte ? "connecte" : "anonyme");
    if (lienConnexion) {
      lienConnexion.hidden = etat.connecte;
      lienConnexion.setAttribute("href", adresseConnexion());
    }
    if (boutonMenu) boutonMenu.hidden = !etat.connecte;
    if (!etat.connecte) fermerMenu(false);
    if (!etat.connecte && waItem) waItem.hidden = true;
    if (!etat.connecte && waPanneau) waPanneau.hidden = true;
    document.querySelectorAll("[data-tms-galeries]").forEach(function (zone) {
      zone.setAttribute("data-etat", etat.connecte ? "connecte" : "anonyme");
      zone.querySelectorAll("[data-tms-si-anonyme], [data-tms-si-connecte]").forEach(function (n) {
        n.hidden = !visible(n);
      });
      zone.querySelectorAll("[data-tms-connexion-lien]").forEach(function (a) {
        a.setAttribute("href", adresseConnexion());
      });
      if (etat.connecte && !sansListe) peindreGaleries(zone);
      else {
        var vide = zone.querySelector("[data-tms-galeries-vide]");
        if (vide) vide.hidden = true;
      }
    });
  }

  /* (revue du lot 18) Chaque « Sign in » porte son `retour` DÈS le démarrage, pas après la sonde : un clic pendant
     ces 4 s ramène quand même à cette page, à cette étape. */
  document.querySelectorAll("[data-tms-connexion-lien], [data-tms-compte-connexion]").forEach(function (a) {
    a.setAttribute("href", adresseConnexion());
  });
  /* ⚠️ Sans page de connexion déclarée, l'en-tête ne rend ni cette racine ni ce script (Liquid, contrat §4) :
     c'est la seule garde, une seconde ici serait inatteignable (mutation survivante du lot 18). */
  sonder();
  /* (lot 22) La page my-family annonce la famille qu'elle vient d'ouvrir (`tms:famille`), parfois APRÈS la sonde
     (famille du compte) : la garde automatique a sa chance ; le bandeau, lui, annonce chaque lecture (`rendreUneChance`). */
  document.addEventListener("tms:famille", function (ev) {
    if (!etat.connu) return;
    peindre(true);
    garderAuto();
    rendreUneChance(ev.detail);
  });
  /* Une page rendue par le retour arrière (bfcache) relance la sonde (contrat §10). */
  window.addEventListener("pageshow", function (ev) {
    if (ev.persisted) sonder();
  });
})();
